import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import withRouter from "../withRouter";

import user1 from "../../../assets/images/users/td_logo.jpeg";

const ProfileMenu = (props) => {
  const [menu, setMenu] = useState(false);
  const [username, setUsername] = useState("System User");
  const [loggedInUserId, setLoggedInUserId] = useState(null);

  useEffect(() => {
    const authUser = localStorage.getItem("authUser");
    if (authUser) {
      try {
        const { user } = JSON.parse(authUser);

        setUsername(`${user.first_name} ${user.last_name}`);
        setLoggedInUserId(user.id);

      } catch (error) {
        console.error("Error parsing authUser:", error);
        setUsername("System User");
      }
    }
  }, [props.success]);

  return (
    <React.Fragment>
      <Dropdown isOpen={menu} toggle={() => setMenu(!menu)} className="d-inline-block">
        <DropdownToggle className="btn header-item" id="page-header-user-dropdown" tag="button">
          <img
            className="rounded-circle header-profile-user"
            src={user1}
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ms-2 me-2">{username}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu-end">

          {/* Profile */}
          <DropdownItem tag="a" href={`/user-info/${loggedInUserId}`}>
            <i className="ri-user-line align-middle me-2" />
            Profile
          </DropdownItem>

          <Link to="/change-password" className="dropdown-item">
            <i className="ri-lock-password-line align-middle me-2" />
            <span>Change password</span>
          </Link>

          <div className="dropdown-divider" />

          <Link to="/logout" className="dropdown-item">
            <i className="ri-shut-down-line align-middle me-2 text-danger" />
            <span>Logout</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any
};

const mapStatetoProps = (state) => {
  const { error, success } = state.profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(ProfileMenu)
);
